import { PanelLeft } from "lucide-react";

import { cn } from "@/lib/utils";

import { Button } from "../ui/button";
import { useSidebar } from "../ui/sidebar";

export function Page({ className, children, ...props }: React.ComponentProps<"div">) {
  const { isMobile, toggleSidebar } = useSidebar();
  return (
    <div data-slot="page" className={cn("@container flex h-full flex-col gap-4", className)} {...props}>
      {isMobile && (
        <Button variant="ghost" size="icon" className="size-7 cursor-pointer" onClick={toggleSidebar}>
          <PanelLeft />
        </Button>
      )}
      {children}
    </div>
  );
}

export function PageHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="page-header"
      className={cn(
        "flex min-h-12 flex-col items-start justify-between gap-4 px-4 pb-2 @sm:flex-row @sm:items-center @md:px-0",
        className,
      )}
      {...props}
    />
  );
}

export function PageTitle({ className, ...props }: React.ComponentProps<"h2">) {
  return <h2 data-slot="page-title" className={cn("flex-1 text-3xl font-bold", className)} {...props} />;
}

export function PageHeaderActions({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="page-header-actions" className={cn("shrink-0", className)} {...props} />;
}

export function PageControls({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="page-controls" className={cn("", className)} {...props} />;
}

export function PageContent({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="page-content" className={cn("flex-[1_1_0] overflow-scroll", className)} {...props} />;
}

export function PageFooter({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="page-footer" className={cn("shrink-0", className)} {...props} />;
}
